import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
} from "reactstrap";
import gameimg1 from "../../assets/kangaroo/gamestep1.png";
import gameimg2 from "../../assets/kangaroo/gamestep2.png";
import gameimg3 from "../../assets/kangaroo/gamestep31.png";
import gameimg4 from "../../assets/kangaroo/gamestep4.png";
import gameimg5 from "../../assets/kangaroo/gamestep5.png";
import img1 from "../../assets/kangaroo/sydney types.png";
import img2 from "../../assets/kangaroo/tower types.png";
import img3 from "../../assets/kangaroo/smthg clock tpes.png";
import img4 from "../../assets/kangaroo/usa types.png";
import img5 from "../../assets/kangaroo/canada types.png";
import img6 from "../../assets/kangaroo/yesno.png";
import nepal from "../../assets/kangaroo/nepalflag.png";
import australiaFlag from "../../assets/kangaroo/newzealandflag.png";
import newZealandFlag from "../../assets/kangaroo/newzealandflag.png";
import ukFlag from "../../assets/kangaroo/newzealandflag.png";
import usaFlag from "../../assets/kangaroo/canadaflag.png";
import chinaFlag from "../../assets/kangaroo/newzealandflag.png";
import hat from "../../assets/kangaroo/hat.png";
import migration from "../../assets/kangaroo/migration.png";
import health from "../../assets/kangaroo/health.png";
import taximg from "../../assets/kangaroo/taximg.png";
import mix from "../../assets/kangaroo/mix.png";
import visaimg from "../../assets/kangaroo/visaimg.png";
import notsure from "../../assets/kangaroo/not-sure.png";
import { X } from "lucide-react";
import Smallbutton from "../button/Smallbutton";
import { hr } from "framer-motion/client";
import Dropdown from "../dropdown/Dropdown";
import { useMutation, useQuery } from "@tanstack/react-query";
import BranchService from "../../services/BranchService";
import country from "../../common/data/country";
import * as Yup from "yup";
import { useFormik } from "formik";
import FormService from "../../services/FormService";

const MultiStepForm = ({ isOpen, toggleModal, onComplete, formOrigin }) => {
  // Individual states for each question
  const [open, setOpen] = useState(isOpen)
  const [currentSituation, setCurrentSituation] = useState(null); // Step 2
  const [serviceNeeded, setServiceNeeded] = useState(null);       // Step 3
  const [timeframe, setTimeframe] = useState(null);               // Step 4
  const [supportType, setSupportType] = useState(null);          // Step 5

  // Modal states
  const [modalTwo, setModalTwo] = useState(false);
  const [modalThree, setModalThree] = useState(false);
  const [modalFour, setModalFour] = useState(false);
  const [modalFive, setModalFive] = useState(false);
  const [modalSix, setModalSix] = useState(false);
  const [modalSeven, setModalSeven] = useState(false);

  const toggleModalTwo = () => setModalTwo(prev => !prev);
  const toggleModalThree = () => setModalThree(prev => !prev);
  const toggleModalFour = () => setModalFour(prev => !prev);
  const toggleModalFive = () => setModalFive(prev => !prev);
  const toggleModalSix = () => setModalSix(prev => !prev);
  const toggleModalSeven = () => setModalSeven(prev => !prev);
  const contactnumber = country
  // Country code & office selection
  const [countryCode, setCountryCode] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  console.log("🚀 ~ MultiStepForm ~ selectedItem:", selectedItem)
  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);
  // Close all modals and reset everything
  const closeAllModals = () => {
    setOpen(false);

    setModalTwo(false);
    setModalThree(false);
    setModalFour(false);
    setModalFive(false);
    setModalSix(false);
    setModalSeven(false);

    // Reset all selections
    setCurrentSituation(null);
    setServiceNeeded(null);
    setTimeframe(null);
    setSupportType(null);
    setCountryCode(null);
    setSelectedItem(null);
    formik.resetForm();
  };

  const closeBtn = (
    <div className="w-100 d-flex justify-content-end">
      <button className="close-btn" onClick={closeAllModals}>
        <X color="gray" />
      </button>
    </div>
  );

  // Data for each step
  const images = [
    { src: img1, title: "I’m currently studying in Australia" },
    { src: hat, title: "I’ve completed my studies / about to graduate" },
    { src: visaimg, title: "I’m on a temporary visa (student / graduate / visitor)" },
    { src: notsure, title: "I’m not sure what my next step should be" },
  ];

  const time = [
    { src: hat, title: "Education & Enrolment Support" },
    { src: migration, title: "Visa & Migration Guidance" },
    { src: health, title: "OSHC / OVHC Health Cover" },
    { src: taximg, title: "Tax Return & Compliance" },
    { src: mix, title: "A mix of the above" },
  ];

  const fields = ["Immediately", "Within the next 1-3 months", "In 3-6 months"];

  const questions = [
    "Book a one-to-one consultation",
    "I’d like someone to contact me",
    "I need help reviewing my situation",
    "I want guidance on my next step",
  ];

  // Fetch offices
  const fetchOffice = async () => {
    const response = await BranchService.getList();
    return response?.items;
  };

  const { data: officeData } = useQuery({
    queryKey: ["officeData"],
    queryFn: fetchOffice,
  });

  const officeOptions = officeData?.map(item => ({
    id: item.id,
    label: item.officeName,
  })) || [];
  console.log("🚀 ~ MultiStepForm ~ officeOptions:", officeOptions)

  // Validation schema
  const validationSchema = Yup.object({
    fullName: Yup.string().min(2, 'Full name must be at least 2 characters').required('Full Name is required'),
    email: Yup.string()
      .trim()
      .required("Email address is required")
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
        "Please enter a valid email address"
      )
      .max(254, "Email address is too long"),
    phoneNumber: Yup.string().matches(/^\d{4,15}$/, 'Phone number must be 4–15 digits').required('Phone Number is required'),
    countryCode: Yup.string().required('Country code is required'),

    message: Yup.string(),
  });

  // Form submission mutation
  const mutation = useMutation({
    mutationFn: async (formData) => await FormService.create(formData),
    onSuccess: () => console.log("Form submitted successfully"),
    onError: (error) => console.error("Error submitting form:", error),
  });

  // Formik setup
  const formik = useFormik({
    initialValues: {
      fullName: '',
      email: '',
      countryCode: countryCode?.label || '+61',
      phoneNumber: '',
      preferedBranchId: null,
      message: '',
      formOrigin: formOrigin
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const submissionData = {
        fullName: values.fullName,
        email: values.email,
        phone: `${values.countryCode}${values.phoneNumber}`,
        countryCode: values.countryCode,
        phoneNumber: values.phoneNumber,
        preferedBranchId: values?.preferedBranchId,
        message: values.message,
        formOrigin: values.formOrigin,

        // Correctly mapped selections from each step
        currentSituation: currentSituation?.title || '',
        serviceHelp: serviceNeeded || '',
        callBackTime: timeframe || '',
        support: supportType || '',
      };

      console.log('Form Submission Payload:', submissionData);
      mutation.mutate(submissionData);

      // Show thank you modal
      toggleModalSix();
      toggleModalSeven();

      // Reset everything
      resetForm();
      setCurrentSituation(null);
      setServiceNeeded(null);
      setTimeframe(null);
      setSupportType(null);
      setCountryCode(null);
      setSelectedItem(null);
      setSubmitting(false);

      if (onComplete) onComplete();
    },
  });
  console.log("🚀 ~ MultiStepForm ~ formik:", formik)

  // Sync country code and office with formik
  useEffect(() => {
    if (countryCode) {
      formik.setFieldValue('countryCode', countryCode.label);
    }
  }, [countryCode]);

  useEffect(() => {
    formik.setFieldValue('preferedBranchId', selectedItem?.id);
  }, [selectedItem]);

  return (
    <>
      {/* Modal 1: Welcome */}
      <Modal isOpen={open} toggle={toggleModal} size="lg" backdrop="static">
        <ModalHeader toggle={toggleModal} close={closeBtn} style={{ borderBottom: "0px" }} />
        <ModalBody className="p-0">
          <div className="py-4" style={{ marginLeft: "4rem" }}>
            <Row>
              <Col>
                <h1 className="game-font lh-1">HI! I'M SMART <br /> KANGAROO,</h1>
                <p className="game-subtext-font lh-1">here to guide you through <br /> your next step in Australia</p>
                <p className="game-desc-font lh-1">Let's find the right support for you - it takes <br /> less than 30 seconds!</p>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col>
                <div onClick={() => { toggleModal(); toggleModalTwo(); }}>
                  <Smallbutton text="BEGIN" />
                </div>
              </Col>
            </Row>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-end" }}>
            <img src={gameimg1} alt="" style={{ width: "550px", height: "auto" }} />
          </div>
        </ModalBody>
      </Modal>

      {/* Modal 2: Current Situation */}
      <Modal isOpen={modalTwo} toggle={toggleModalTwo} size="lg" backdrop="static">
        <ModalHeader toggle={toggleModalTwo} close={closeBtn} style={{ borderBottom: "0px" }} />
        <ModalBody className="p-0">
          <div className="" style={{ marginLeft: "4rem", marginRight: "4rem" }}>
            <h1 className="font-level-5 lh-1">WHAT BEST DESCRIBES <br /> YOUR CURRENT <br /> SITUATION?</h1>
            <Row className="mt-4">
              {images.map((item, index) => {
                const isSelected = currentSituation?.src === item.src;
                return (
                  <Col xs={12} key={index}>
                    <hr style={{ borderTop: "1.5px solid #5c5858" }} />
                    <div
                      className="d-flex align-items-center"
                      style={{ cursor: "pointer" }}
                      onClick={() => setCurrentSituation(item)}
                    >
                      <input
                        type="radio"
                        checked={isSelected}
                        readOnly
                        className="form-check-input flex-shrink-0"
                        style={{ width: "28px", height: "28px", marginRight: "20px", border: "1px solid #5c5858" }}
                      />
                      <img src={item.src} alt={item.title} style={{ width: "54px", borderRadius: "12px" }} />
                      <div className="ms-4 flex-grow-1">
                        <h5 style={{ margin: 0, fontWeight: isSelected ? "700" : "600", fontSize: "1.25rem" }}>
                          {item.title}
                        </h5>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
            <div className="d-flex jusitfy-content-center align-items-center">
              <Row>
                <Col className="mt-4">
                  <div
                    onClick={() => {
                      toggleModalTwo();
                      toggleModalThree();
                    }}
                  >
                    <Smallbutton text="NEXT" />
                  </div>
                </Col>
              </Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-end",
                  width: "100%",
                  marginTop: "20px",
                  padding: "0px",
                  // spacing from content
                }}
              >
                <img
                  src={gameimg2}
                  alt=""
                  fluid
                  style={{
                    width: "550px", // adjust size

                    height: "auto",
                    marginLeft: "2.7rem",
                  }}
                />
              </div>

            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Modal 3: Service Needed */}
      <Modal isOpen={modalThree} toggle={toggleModalThree} size="lg" backdrop="static">
        <ModalHeader toggle={toggleModalThree} close={closeBtn} style={{ borderBottom: "0px" }} />
        <ModalBody className="p-0">
          <div className="" style={{ marginLeft: "4rem" }}>
            <h1 className="font-level-5 lh-1">WHAT DO YOU NEED <br /> HELP WITH RIGHT NOW?</h1>
            <div className="d-flex justify-content-between align-items-start mt-4">
              <div style={{ flex: "0 0 55%" }}>
                {time.map((field, index) => {
                  const isSelected = serviceNeeded === field.title;
                  return (
                    <div key={index}>
                      <hr style={{ borderTop: "1.5px solid #5c5858", margin: "0" }} />
                      <div
                        className="d-flex align-items-center py-4"
                        style={{ cursor: "pointer" }}
                        onClick={() => setServiceNeeded(field.title)}
                      >
                        <input
                          type="radio"
                          checked={isSelected}
                          readOnly
                          className="form-check-input flex-shrink-0"
                          style={{ width: "28px", height: "28px", marginRight: "20px" }}
                        />
                        <img src={field.src} alt={field.title} style={{ width: "54px", borderRadius: "12px" }} />
                        <div className="ms-4">
                          <h5 style={{ margin: 0, fontWeight: isSelected ? "700" : "600", fontSize: "1.25rem" }}>
                            {field.title}
                          </h5>
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div style={{ marginTop: "7.5rem" }}>
                  <div onClick={() => { toggleModalThree(); toggleModalFour(); }}>
                    <Smallbutton text="NEXT" />
                  </div>
                </div>
              </div>
              <div
                className="d-flex justify-content-end align-items-end"
                style={{ flex: "0 0 40%" }}
              >
                <img src={gameimg3} alt="" className="w-100" />
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Modal 4: Timeframe */}
      <Modal isOpen={modalFour} toggle={toggleModalFour} size="lg" backdrop="static">
        <ModalHeader toggle={toggleModalFour} close={closeBtn} style={{ borderBottom: "0px" }} />
        <ModalBody className="p-0">
          <div className="py-4" style={{ marginLeft: "4rem", marginRight: "4rem" }}>
            <h1 className="font-level-5 lh-1">WHEN DO YOU <br /> NEED SUPPORT?</h1>
            <Row className="mt-4">
              {fields.map((field, index) => {
                const isSelected = timeframe === field;
                return (
                  <Col xs={12} key={index}>
                    <hr style={{ borderTop: "1.5px solid #5c5858", margin: "0" }} />
                    <div
                      className="d-flex align-items-center py-4 px-3"
                      style={{ cursor: "pointer" }}
                      onClick={() => setTimeframe(field)}
                    >
                      <input
                        type="radio"
                        checked={isSelected}
                        readOnly
                        className="form-check-input flex-shrink-0"
                        style={{ width: "28px", height: "28px", marginRight: "20px" }}
                      />
                      <label style={{ fontSize: "1.25rem", fontWeight: isSelected ? "700" : "500", cursor: "pointer" }}>
                        {field}
                      </label>
                    </div>
                  </Col>
                );
              })}
            </Row>
            <Row className="mt-5 mb-5 pb-5">
              <Col>
                <div onClick={() => { toggleModalFour(); toggleModalFive(); }}>
                  <Smallbutton text="NEXT" />
                </div>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </Modal>

      {/* Modal 5: Support Type */}
      <Modal isOpen={modalFive} toggle={toggleModalFive} size="lg" backdrop="static">
        <ModalHeader toggle={toggleModalFive} close={closeBtn} style={{ borderBottom: "0px" }} />
        <ModalBody className="p-0">
          <div className="pt-4" style={{ marginLeft: "4rem" }}>
            <h1 className="font-level-5 lh-1">HOW WOULD YOU LIKE <br /> KEVS TO SUPPORT YOU?</h1>
            <Row className="mt-4">
              {questions.map((field, index) => {
                const isSelected = supportType === field;
                return (
                  <Col xs={12} key={index}>
                    <hr style={{ borderTop: "1.5px solid #5c5858", margin: "0" }} />
                    <div
                      className="d-flex align-items-center py-4 px-3"
                      style={{ cursor: "pointer" }}
                      onClick={() => setSupportType(field)}
                    >
                      <input
                        type="radio"
                        checked={isSelected}
                        readOnly
                        className="form-check-input flex-shrink-0"
                        style={{ width: "28px", height: "28px", marginRight: "20px" }}
                      />
                      <label style={{ fontSize: "1.25rem", fontWeight: isSelected ? "700" : "500" }}>
                        {field}
                      </label>
                    </div>
                  </Col>
                );
              })}
            </Row>
            <div className="d-flex justify-content-between align-items-center mt-4 ">
              <Row>
                <Col className="mt-4">
                  <div
                    onClick={() => {
                      toggleModalFive();
                      toggleModalSix();
                    }}
                  >
                    <Smallbutton text="NEXT" />
                  </div>
                </Col>
              </Row>
              <img
                src={gameimg4}
                alt=""
                style={{
                  maxWidth: "100%",
                  width: "400px",
                  height: "auto",
                }}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Modal 6: Contact Form */}
      <Modal isOpen={modalSix} toggle={toggleModalSix} size="lg" backdrop="static">
        <ModalHeader toggle={toggleModalSix} close={closeBtn} style={{ borderBottom: '0px' }} />
        <ModalBody className="p-0">
          <div className="py-4" style={{ marginLeft: '4rem', marginRight: '4rem' }}>
            <h1 className="font-level-5 lh-1">
              GREAT, WE’LL TAILOR OUR <br /> SUPPORT BASED ON <br /> YOUR SITUATION.
            </h1>
            <p className="game-desc-font lh-1">
              Please complete the form below so we can reach out <br /> and assist you further.
            </p>

            <form onSubmit={formik.handleSubmit}>
              {/* Full Name */}
              <Row className="mt-4">
                <Col>
                  <label className="font-label">Full Name*</label>
                  <input
                    type="text"
                    className="form-control form-box py-3"
                    name="fullName"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.fullName}
                  />
                  {formik.touched.fullName && formik.errors.fullName && (
                    <div className="text-danger small mt-1">{formik.errors.fullName}</div>
                  )}
                </Col>
              </Row>

              {/* Email */}
              <Row className="mt-3">
                <Col>
                  <label className="font-label">Email Address*</label>
                  <input
                    type="email"
                    className="form-control form-box py-3"
                    name="email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="text-danger small mt-1">{formik.errors.email}</div>
                  )}
                </Col>
              </Row>

              {/* Phone */}
              <Row className="mt-3">
                <Col>
                  <label className="font-label">Phone Number*</label>
                  <div className="d-flex">
                    <Dropdown
                      items={contactnumber.map(item => ({
                        id: item.id,
                        label: item.countryCode,
                        flag: item.flagImg,
                      }))}
                      selectedItem={countryCode}
                      setSelectedItem={setCountryCode}
                      phoneNumber={true}
                      placeholder="+61"
                      placeholderFlag={australiaFlag}
                      width="9rem"
                    />
                    <input
                      type="text"
                      className="form-control form-box py-3"
                      style={{ borderLeft: 0, borderRadius: "0 8px 8px 0" }}
                      name="phoneNumber"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.phoneNumber}
                    />
                  </div>
                  {(formik.touched.phoneNumber && formik.errors.phoneNumber) ||
                    (formik.touched.countryCode && formik.errors.countryCode) ? (
                    <div className="text-danger small mt-1">
                      {formik.errors.phoneNumber || formik.errors.countryCode}
                    </div>
                  ) : null}
                </Col>
              </Row>

              {/* Nearest Office */}
              <Row className="mt-3">
                <Col>
                  <label className="font-label">Nearest KEVS Offices*</label>
                  <Dropdown
                    items={officeOptions}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                    placeholder="Select an office"
                  />
                  {formik.touched.preferedBranchId && formik.errors.preferedBranchId && (
                    <div className="text-danger small mt-1">{formik.errors.preferedBranchId}</div>
                  )}
                </Col>
              </Row>

              {/* Message */}
              <Row className="mt-3">
                <Col>
                  <label className="font-label">Message (if any)</label>
                  <textarea
                    className="form-control form-box"
                    name="message"
                    rows={8}
                    style={{ resize: 'vertical' }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.message}
                  />
                </Col>
              </Row>

              <button
                type="submit"
                className="btn border-0"
                disabled={formik.isSubmitting || !formik.isValid}
                style={{ marginTop: '8rem', marginBottom: '9rem' }}
              >
                <Smallbutton text="SUBMIT" />
              </button>
            </form>
          </div>
        </ModalBody>
      </Modal>

      {/* Modal 7: Thank You */}
      <Modal isOpen={modalSeven} toggle={toggleModalSeven} size="lg" backdrop="static" contentClassName="game-end">
        <ModalHeader toggle={toggleModalSeven} close={closeBtn} style={{ borderBottom: "0px" }} />
        <ModalBody className="p-0">
          <div className="d-flex justify-content-center align-items-center">
            <div style={{ width: "45%" }}>
              <img src={gameimg5} alt="" className="w-100 h-100" />
            </div>
            <div style={{ width: "55%" }} className="text-white">
              <h1 className="font-level-5 lh-1" style={{ color: "#fff" }}>THANK YOU, <br /> YOU'RE ALL SET!</h1>
              <p className="game-desc-font my-3 pe-5 lh-1" style={{ color: "#fff" }}>
                We’ve received your details. Our team will reach out shortly to guide you with your next steps.
              </p>
              <div className="mt-5" onClick={closeAllModals}>
                <Smallbutton text="CLOSE" fill="transparent" strokeColor="#fff" textColor="#fff" />
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default MultiStepForm;